import { IMarker } from 'src/interfaces/Marker';
import { MARKER_TYPE } from 'src/interfaces/enums';
import { post, put, del } from 'src/utils/apiUtils';
import { IApplicationData } from 'src/interfaces/ApplicationData';
import { IMarkerService } from 'src/interfaces/MarkerService';
import { MARKER_URL } from './constants';

class MarkerServiceV1 implements IMarkerService {
  private applicationData: IApplicationData;

  constructor(applicationData: IApplicationData) {
    this.applicationData = applicationData;
  }

  private generateRequestUrlTo(method: string, params?: unknown) {
    const { reference, signature, mediaCode, userCode, applicationKey } = this.applicationData;

    switch (method) {
      case 'post':
        return `${MARKER_URL}/${mediaCode}?signature=${signature}&application-key=${applicationKey}`;
      case 'put':
        return `${MARKER_URL}/${params}/${
          reference || userCode
        }?signature=${signature}&application-key=${applicationKey}`;
      case 'delete':
        return `${MARKER_URL}/${params}/${reference || userCode}`;
      default:
        return '';
    }
  }

  get commonRequestParams() {
    const { reference, canEditMarkers: isProducer, userCode } = this.applicationData;

    const type = isProducer ? MARKER_TYPE.MARK : MARKER_TYPE.NOTE;

    return {
      userReference: reference || userCode,
      type,
    };
  }

  insertMarker = (marker: IMarker) => {
    const uri = this.generateRequestUrlTo('post');

    return post(uri, {
      ...marker,
      ...this.commonRequestParams,
    });
  };

  updateMarker = (marker: IMarker) => {
    const uri = this.generateRequestUrlTo('put', marker.id);

    return put(uri, {
      ...marker,
      ...this.commonRequestParams,
    });
  };

  deleteMarker(id: IMarker['id']) {
    const uri = this.generateRequestUrlTo('delete', id);

    return del(uri);
  }
}
export default MarkerServiceV1;
